import React, { ReactNode, useContext } from 'react';
import tableContext from './tableContext';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    className?: string;
}

const TableRow: React.FC<Props> = ({ children, className = '', ...rest }) => {
    const { numOfColumns } = useContext(tableContext);

    if (!numOfColumns) return null;

    return (
        <div className={`row ${className}`} {...rest}>
            {children}
            <div className='border' style={{ gridColumn: `1/${numOfColumns + 1}` }} />
        </div>
    );
};

export default TableRow;
